import { InjectionToken } from '@angular/core';

/**
 * The nav items in beta, by `routerLink` (AT-2264). This list is the only place an item is flagged.
 *
 * A listed item shows a Beta pill beside its label, and while any item on screen is listed, the
 * feedback note sits under the menu. Label only: it neither hides nor gates anything. Whether an
 * item is in the menu at all is its feature's availability file, so a route listed here whose item
 * the menu leaves out (a dev-only item on production, say) shows nothing.
 *
 * To flag an item, add its `routerLink` exactly as the nav item has it; to unflag, delete the line.
 * A change reaches each environment with that environment's own deploy: merging to dev updates dev
 * only, and staging and production change when the work is promoted to them. How-to: README.md,
 * "Beta badges in the dashboard nav".
 *
 * A token rather than a constant so a spec can provide its own list.
 */
export const BETA_NAV_ROUTES = new InjectionToken<readonly string[]>('BETA_NAV_ROUTES', {
  providedIn: 'root',
  factory: (): readonly string[] => [
    '/collaboration/portfolio',
    '/collaboration/review',
    '/tax-audit',
    '/collaboration/invoices',
    '/marketplace/browse',
    '/marketplace/applications',
  ],
});
